import { createFileRoute } from '@tanstack/react-router';

import { CorrespondenciaInboxPage } from '@/features/virtual-offices/components/correspondencia-inbox-page';

export const Route = createFileRoute('/_app/virtual-offices/correspondencia')({
  component: CorrespondenciaInboxPage,
});
